import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../core/api.service';
import { I18nService } from '../../core/i18n.service';

const CONTACT_EMAIL = 'contact@phdcompass.net';

@Component({ selector: 'app-contact', standalone: true, imports: [FormsModule], templateUrl: './contact.html', styleUrl: './contact.scss', schemas: [CUSTOM_ELEMENTS_SCHEMA] })
export class Contact {
  email = '';
  message = '';
  readonly contactEmail = CONTACT_EMAIL;
  status: 'idle' | 'invalid' | 'captcha' | 'sent' | 'error' = 'idle';
  isSubmitting = false;
  altchaPayload = '';
  captchaError = false;

  constructor(public i18n: I18nService, private api: ApiService) {}

  get captchaChallengeUrl(): string {
    return this.api.contactCaptchaUrl;
  }

  async sendMessage(): Promise<void> {
    if (this.isSubmitting) return;

    const email = this.email.trim();
    const message = this.message.trim();
    if (!email || !message) {
      this.status = 'invalid';
      return;
    }
    if (!this.altchaPayload) {
      this.status = 'captcha';
      return;
    }

    this.isSubmitting = true;
    try {
      await this.api.sendContactRequest({ email, message, altcha: this.altchaPayload });
      this.status = 'sent';
      this.message = '';
    } catch {
      this.status = 'error';
    } finally {
      this.altchaPayload = '';
      this.isSubmitting = false;
    }
  }

  onCaptchaStateChange(event: Event): void {
    const detail = (event as CustomEvent<{ state?: string; payload?: string }>).detail;
    this.altchaPayload = detail?.state === 'verified' && detail.payload ? detail.payload : '';
    this.captchaError = detail?.state === 'error';
    if (this.altchaPayload && this.status === 'captcha') this.status = 'idle';
  }
}
